<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8VRBpW/tc-custom/9781614239734.jpg?1736610491576" alt="This image is the cover for the book Haunted Colleges & Universities of Massachusetts, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Colleges & Universities of Massachusetts, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>Get an education in ghostly history—and meet the spirits that haunt schools in Boston and beyond. Includes photos!</b><br/>  <br/> Among the throngs of students attending colleges and universities across the state of Massachusetts linger the apparitions of those who met their untimely ends on campus grounds. In 1953, Eugene O’Neill, an Irish American playwright, died in room 401 of the Sheraton Hotel—today a Boston University dormitory. Named Writer’s Corridor in O’Neill’s honor, the fourth floor draws students in search of creative inspiration and a sighting of the ghostly writer. A grief-stricken widow roams the halls of Winthrop Hall at Endicott College in her pink wedding gown. She threw herself from her widow’s walk after receiving news of her husband's death at sea, and is known to students today as the “pink lady.”<br/>  <br/> Author Renee Mallett reveals the stories behind these “school spirits”—and offers eerie stories from over two dozen colleges and universities throughout the Bay State.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Renee Mallett
      </h2>
      
      <p class="authorDescription body article">Renee Mallett is the author of several books about ghosts and legends in the New England states and has also published numerous pieces of writing ranging from short fiction and poetry to celebrity interviews and travel essays. Learn more about the author at ReneeMallett.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dcf8f45a